import { Link, useLocation } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";

/**
 * Persistent bottom action bar on mobile, the single highest-use
 * mobile conversion element. Keeps the primary action ("Get a Free Quote")
 * and a one-tap call in reach on every scroll position.
 *
 * Hidden on desktop (md+ has the header CTAs) and on the quote funnel / admin
 * so it never covers the form it's driving people toward.
 */
export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  const { config, getLocalePath } = useI18n();

  const hidden =
    /(^|\/)(quote)(\/|$)/.test(pathname) || pathname.includes("/admin");
  if (hidden) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 md:hidden border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 shadow-[0_-4px_20px_-4px_rgba(0,0,0,0.12)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-stretch gap-2 px-3 py-2.5">
        <a
          href={`tel:${config.phone}`}
          className="flex flex-1 items-center justify-center gap-2 rounded-md border border-secondary/30 bg-secondary/5 px-3 py-3 text-sm font-semibold text-secondary transition-colors hover:bg-secondary/10"
          aria-label={`Call MTLI at ${config.phone}`}
        >
          <Phone className="h-4 w-4" />
          Call
        </a>
        <Link
          to={getLocalePath("/book-a-call")}
          className="flex flex-[1.6] items-center justify-center gap-2 rounded-md bg-primary px-4 py-3 text-sm font-bold text-primary-foreground shadow-lg shadow-primary/25 transition-transform active:scale-[0.98]"
        >
          Book a Call
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
